// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TAddFlatTourBookingRequest,
  TAddFlatTourBookingModel,
  IMappers,
  TAddFlatTourBookingResponse,
  IAddFlatTourBookingResponseData400,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IAddFlatTourBookingResponse } from '../../entities/Models/AddFlatTourBookingResponse';

export function createAddFlatTourBookingModel(parameters: TAddFlatTourBookingRequest): TAddFlatTourBookingModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'newbuilding-flat-tour-booking',
    pathApi: '/v1/add-flat-tour-booking',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IAddFlatTourBookingOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TAddFlatTourBookingRequest;
}

export async function fetchAddFlatTourBooking<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IAddFlatTourBookingOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TAddFlatTourBookingResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createAddFlatTourBookingModel(parameters),
    config,
  )) as FetchResponse<TAddFlatTourBookingResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IAddFlatTourBookingResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IAddFlatTourBookingResponseData400, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TAddFlatTourBookingResponse>;
}
